import { render, staticRenderFns } from "./ItemsMap.vue?vue&type=template&id=16b988c7&scoped=true&"
import script from "./ItemsMap.vue?vue&type=script&lang=js&"
export * from "./ItemsMap.vue?vue&type=script&lang=js&"
import style0 from "./ItemsMap.vue?vue&type=style&index=0&id=16b988c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b988c7",
  null
  
)

export default component.exports